export const createPolymorphicComponent = (component) => {
    return component;
};
